import { Grid } from 'gridjs'
import { appendInputGroup, createTable } from '../General/utils'

const initialise = () => {
	const element = document.getElementById('EnterpriseLicenceTable') as HTMLTableElement
	const renderedID = createTable(element) as string
	new Grid({
		pagination: {
			limit: 200
		},
		sort: true,
		search: true,
		resizable: true,
		language: {
			search: {
				placeholder: 'Search...'
			},
			pagination: {
				previous: '<',
				next: '>',
				showing: '😃 Displaying',
				results: () => 'Records'
			}
		},
		from: element
	}).render(document.getElementById(renderedID)!)

	appendInputGroup(element.getAttribute('name')!)
}
window.addEventListener('load', () => {
	initialise()
})
export {}